<template>
  <div>
    <v-content style="color:#333333;background-color:#ffffff;" class="pa-5">
      <div v-html="emailBody"></div>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<style scoped>
</style>

<script>
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'deliveryOrderNo'
  ],
  components: {
    Loading
  },
  data () {
    return {
      loading: false,
      emailBody: ''
    }
  },
  mounted () {
    this.getDeliveryOrderDetails()
    this.disableBottomDetector()
  },
  methods: {
    getDeliveryOrderDetails: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/delivery/' + _this.deliveryOrderNo)
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.emailBody = resp.data.data.emailBody
            this.forceUpdate()
          } else {
            console.log('unable to load delivery order email: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(this)
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    }
  }
}
</script>
